export const cyberbullyingStoriesCardsConfig = {
  xsmall: {
    contentAlignment: {
      vertical: 'bottom',
      horizontal: 'middle',
    },
    gridSetup: {
      image: {
        columns: 16,
      },
      content: {
        columns: 16,
      },
      card: {
        columns: 16,
      },
    },
  },
  small: {
    contentAlignment: {
      vertical: 'top',
    },
    gridSetup: {
      image: {
        columns: 4,
      },
      content: {
        columns: 12,
      },
      card: {
        columns: 16,
      },
    },
  },
};

export const cyberbullyingStoriesNthCardsConfig = [
  {
    xsmall: {
      contentAlignment: {
        horizontal: 'left',
        vertical: 'bottom',
      },
    },
  },
  {
    xsmall: {
      contentAlignment: {
        horizontal: 'right',
        vertical: 'bottom',
      },
    },
  },
];
